export default __webpack_public_path__ + "static/media/post-1.30e14ebf.png";